import React, { Component } from 'react';
import { Query } from 'react-apollo';
import ListRow from './ListRow';
import { FERTILIZER_TYPES } from '../constants/fertilizer.constants';
import { FERTILIZERS_LIST } from '../queries/fertilizer.query';
import Loader from "../../common/components/Loader/Loader";
import ErrorFetch from "../../common/components/Error/ErrorFetch";

class FertilizersList extends Component {
  state = { selectedType: 'ALL'};

  handleTypeSelect = ({ target }) =>
    this.setState({ selectedType: target.value });

  render() {
    const { selectedType } = this.state;
    const typeCode = selectedType === 'ALL' ? undefined : selectedType;
    return [
      <select
        className="select"
        onChange={this.handleTypeSelect}
        value={this.state.selectedType}
      >
        <option value="ALL">Visos trąšos</option>
        {FERTILIZER_TYPES.map(item => (
          <option
            key={`seedTypeOption${item.type}`}
            value={item.type}
            onChange={this.handleTypeSelect}
          >
            {item.label}
          </option>
        ))}
      </select>,
      <div className="ListItemsContainer">
        <table className="table" align="center">
          <tbody>
            <tr>
              <td className="text-left">
                <strong>Prekė</strong>
              </td>
              <td>
                <strong>Norma</strong>
              </td>
              <td>
                <strong>Kaina (vnt.)</strong>
              </td>
              {/*<td />*/}
            </tr>
            <Query
              query={FERTILIZERS_LIST}
              variables={{ typeCode }}
            >
              {({ loading, data }) =>
                loading ? <Loader /> :
                  !data || !data.fertilizers ? <ErrorFetch /> :
                  data.fertilizers.map(item =>
                    (<ListRow product={item} type="fertilizer" />)
                  )
              }
            </Query>
          </tbody>
        </table>
      </div>
    ]
  }

}

export default FertilizersList;
